import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { loadRuntimeConfig, buildMsalConfig } from './authConfig';
import { RuntimeConfigContext } from './context/RuntimeConfigContext';
import './index.css';

async function bootstrap() {
  const cfg = await loadRuntimeConfig();
  const msalInstance = new PublicClientApplication(buildMsalConfig(cfg));
  await msalInstance.initialize();

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <RuntimeConfigContext.Provider value={cfg}>
        <MsalProvider instance={msalInstance}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </MsalProvider>
      </RuntimeConfigContext.Provider>
    </React.StrictMode>
  );
}

bootstrap();
